/**
 * Configurazioni di default per Sasha Player
 */

/**
 * Configurazione di default per Sasha Player
 * 
 * NOTA: I colori sono stati rimossi da qui e gestiti completamente dai temi CSS.
 * Ogni tema deve definire le seguenti CSS custom properties:
 * - --sasha-bg-color
 * - --sasha-accent-color
 * - --sasha-text-color
 * - --sasha-waveform-color
 * - --sasha-waveform-background-color
 * 
 * @since v2.4.0 - Refactoring completo separazione logica/presentazione
 */
export const DEFAULT_CONFIG = {
  audioUrl: '',
  coverImage: 'https://via.placeholder.com/400x200?text=Audio+Cover',
  title: 'Audio Title',
  subtitle: 'Audio Subtitle',
  skipSeconds: 15,
  showShareButton: true,
  theme: 'default',
  themesPath: 'themes/',
  sponsorLogo: null,
  sponsorClaim: 'In collaborazione con',
  sponsorLink: '#',
  // Sistema ads (v3.0.0+)
  ads: [],
  frequencyCapping: {
    enabled: false,
    storage: 'session',
    maxPlays: 1,
    timeWindow: null
  }
};

export const DEFAULT_ADVANCED = {
  autoplay: false,
  fftSize: 256,
  keyboardControls: true,
  shadowMode: 'open',
  // Web Vitals optimization
  lazyLoad: false,  // Lazy loading per Web Vitals (below the fold)
  // Waveform configuration
  waveformType: 'bar',  // bar | mirrored | line | blocks | gradient
  // Debug utilities
  debugColors: false,
  debugMode: false  // Abilita cache-busting per CSS temi e altre risorse (dev only)
};

export const PLAYER_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  PLAYING: 'playing',
  PAUSED: 'paused',
  ERROR: 'error'
};

export const EVENTS = {
  READY: 'sasha:ready',
  PLAY: 'sasha:play',
  PAUSE: 'sasha:pause',
  ENDED: 'sasha:ended',
  ERROR: 'sasha:error',
  TIME_UPDATE: 'sasha:timeupdate',
  VOLUME_CHANGE: 'sasha:volumechange',
  THEME_LOADED: 'sasha:themeloaded',
  THEME_MANAGER_READY: 'sasha:themeManagerReady',
  CONFIG_READY: 'sasha:configReady',
  // Eventi ads (v3.0.0+)
  AD_START: 'sasha:adstart',
  AD_COMPLETE: 'sasha:adcomplete',
  AD_SKIPPED: 'sasha:adskipped',
  AD_ERROR: 'sasha:aderror',
  AD_PROGRESS: 'sasha:adprogress',
  ALL_ADS_PLAYED: 'sasha:alladsplayed'
};

